module.exports = __webpack_public_path__ + "static/screenie_usage_static-8f2b9bd0c277b66579560ea528451b95.jpg";